module.exports = __webpack_public_path__ + "img/concrete-hole-decal-20.aa7875b1.png";